import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DialogCommentPreStudyReportComponent } from '../dialog-comment-pre-study-report/dialog-comment-pre-study-report.component';
import { MedicalServiceService } from 'src/app/services/medical-service.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';

@Component({
  selector: 'app-dialog-clinical-data',
  templateUrl: './dialog-clinical-data.component.html',
  styleUrls: ['./dialog-clinical-data.component.css']
})
export class DialogClinicalDataComponent implements OnInit {

  loading: boolean;
  comments: string;

  constructor(
    public dialogRef: MatDialogRef<DialogClinicalDataComponent>,
     private medicalServiceService: MedicalServiceService,
     private notificationToastService: NotificationToastService,
     @Inject(MAT_DIALOG_DATA) public medicalAppointmentId: number) {
     this.loading = true;
  }

  async ngOnInit() {
    try {
      this.comments = await this.medicalServiceService.getClinicalData(this.medicalAppointmentId);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Datos clínicos y Antecedentes');
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
